const $breadcrumb = document.body.querySelector('.oce-breadcrumb')
export const breadcrumbDetailsArr = $breadcrumb?.querySelectorAll('.oce-breadcrumb__details')
export const breadcrumbDisplayQuery = window.matchMedia('(min-width: 992px)')
export const expandOrRetractDetails = (e) => {
    if ( !$breadcrumb ) return;
    if (e.matches) {
        breadcrumbDetailsArr.forEach(_$details => {
            _$details.setAttribute('open', 'open')
        })
    } else {
        breadcrumbDetailsArr.forEach(_$details => {
            _$details.removeAttribute('open')
        })
    }
}